import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayError from 'shared/utils/displayError'

interface removeAllFilterValuesProps {
  filterId: number
  permissionId: number
  recentOnly?: boolean
}

const removeAllFilterValues = async (props: removeAllFilterValuesProps) => {

  const formData = {
    filter_id: props.filterId,
    permission_id: props.permissionId,
    recentOnly: props?.recentOnly ?? false
  }

  const catchFunc = (err: AxiosError) => {
      displayError({errorMessage: err.message ?? 'An error occurred'})
  }

  const response = await axiosPost(apiUrls.filterValuesToPermissions + '/' + apiUrls.actionRemoveAll, formData, catchFunc);

  return response.data === true
}

export default removeAllFilterValues
